import Enums from "../../../enums/enums";
import * as api from "../../../service/ApiSevice";
import store from "../../baseController";
export const actions = {
  DoUpdatePeakMission({ commit, state }, input) {
    if (state.insertGuideLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationUpdatePeakGuideLoadingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.DoUpdatePeakMission(input).then((res) => {
        if (res.responseCode.IsSuccess()) {
          commit("MutationUpdatePeakGuideLoadingStatus", Enums.LoadingStatusType.Success);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationUpdatePeakGuideLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
  DoShowPeakGuide({ commit, state }, showPeakGuide, setGuide = false) {
    commit("MutationSetShowPeakGuide", showPeakGuide);

    if (setGuide) {
      commit("MutationSetGuide", setGuide);
    }
  },
  DoGetPeakGuide({ commit, state }) {
    if (state.getPeakGuideLoadingStatus !== Enums.LoadingStatusType.Loading) {
      commit("MutationGetPeakGuideLoadingStatus", Enums.LoadingStatusType.Loading);
      api.UserService.DoGetPeakGuide().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          commit("MutationGetPeakGuideLoadingStatus", Enums.LoadingStatusType.Success);
          commit("MutationGetPeakGuide", res.data.guide);
        } else {
          let alertMessage = shareHelper.GetErrorMessageByExceptionCode(res.data.exception);
          store.dispatch("SetAlertMessage", {
            alertMessage: alertMessage,
            typeMessage: Enums.TypeComponentNoti.error,
          });
          commit("MutationGetPeakGuideLoadingStatus", Enums.LoadingStatusType.Failed);
        }
      });
    }
  },
};
